<div>
  <div class="m-2 d-flex flex-column">
    <span class="header-8">Coverage</span>
    <span class="general-text-6 t">{{ data.coverage }}</span>
    <div class="tab-divider"></div>
  </div>

  <div class="m-2 d-flex flex-column">
    <span class="header-8">Gaps</span>
    <span class="general-text-6 t">{{ data.gaps }}</span>
    <div class="tab-divider"></div>
  </div>
</div>
